import { VIEWPORTS, DESKTOP, isRegistrationScenario } from "./escapeRoomEditorConstants";
import { getScenarioBlockKey, isRegistrationPage } from "./escapeRoomScenarioUtils";

/** Dónde colocar la primera página de un escenario (vacío o al soltar al inicio del bloque), según orden de escenarios. */
export function insertIndexForScenarioBlock(pages, targetScId, scenariosRaw) {
	const sorted = [...(scenariosRaw || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
	const isRegTarget = isRegistrationScenario({ id: targetScId });
	const tIdx = sorted.findIndex((s) => (isRegTarget ? isRegistrationScenario(s) : String(s.id) === String(targetScId)));
	if (tIdx < 0) return pages.length;
	const tOrder = sorted[tIdx].order ?? tIdx;
	const firstInScenario = pages.findIndex((p) => getScenarioBlockKey(p) === String(targetScId) || (isRegTarget && isRegistrationPage(p)));
	if (firstInScenario >= 0) return firstInScenario;
	let insertAt = 0;
	for (let i = 0; i < pages.length; i++) {
		const p = pages[i];
		const pKey = getScenarioBlockKey(p);
		const si = sorted.findIndex((s) => (isRegistrationScenario(s) ? pKey === String(s.id) : String(s.id) === pKey));
		if (si < 0) {
			insertAt = i + 1;
			continue;
		}
		const pOrder = sorted[si].order ?? si;
		if (pOrder < tOrder || (pOrder === tOrder && si < tIdx)) {
			insertAt = i + 1;
		} else {
			break;
		}
	}
	return Math.min(Math.max(0, insertAt), pages.length);
}

const QUIZ_LAYOUT_IDS = new Set(["row", "columns", "grid"]);

/** Disposición de opciones según pestaña de vista (desktop / tablet / mobile). */
export function getQuizOptionsLayoutForBreakpoint(firstQ, viewportId) {
	const base = QUIZ_LAYOUT_IDS.has(firstQ?.optionsLayout) ? firstQ.optionsLayout : "row";
	if (viewportId === "tablet") {
		const t = firstQ?.optionsLayoutTablet;
		if (typeof t === "string" && t.trim() && QUIZ_LAYOUT_IDS.has(t)) return t;
		return base;
	}
	if (viewportId === "mobile") {
		const m = firstQ?.optionsLayoutMobile;
		if (typeof m === "string" && m.trim() && QUIZ_LAYOUT_IDS.has(m)) return m;
		const tb = firstQ?.optionsLayoutTablet;
		if (typeof tb === "string" && tb.trim() && QUIZ_LAYOUT_IDS.has(tb)) return tb;
		return base;
	}
	return base;
}

export function getElementsForViewport(page, viewportId) {
	const baseElements = page?.elements || [];
	if (viewportId === "desktop") return baseElements;
	const vp = VIEWPORTS.find((v) => v.id === viewportId);
	if (!vp) return baseElements;
	const scaleX = vp.width / DESKTOP.width;
	const scaleY = vp.height / DESKTOP.height;
	const scale = Math.min(scaleX, scaleY);
	return baseElements.map((el) => {
		const override = el?.breakpoints?.[viewportId];
		if (override && typeof override.x === "number") {
			const merged = {
				...el,
				x: override.x,
				y: override.y ?? el.y,
				width: override.width ?? el.width,
				height: override.height ?? el.height,
			};
			if (override.content) merged.content = { ...(el.content || {}), ...override.content };
			if (override.style) merged.style = { ...(el.style || {}), ...override.style };
			return merged;
		}
		return {
			...el,
			x: Math.round((el.x || 0) * scale),
			y: Math.round((el.y || 0) * scale),
			width: Math.round((el.width || 100) * scale),
			height: Math.round((el.height || 50) * scale),
		};
	});
}
